// import React, { useState, useEffect, useCallback } from "react";
// import { Routes, Route, NavLink, Link, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   Menu,
//   Dropdown,
//   Avatar,
//   Button,
//   Badge,
//   Input,
//   Drawer,
//   Space,
//   Divider,
//   Typography
// } from "antd";
// import {
//   HomeOutlined,
//   BookOutlined,
//   InfoCircleOutlined,
//   PhoneOutlined,
//   TeamOutlined,
//   UserOutlined,
//   LogoutOutlined,
//   SettingOutlined,
//   ShoppingOutlined,
//   SearchOutlined,
//   AppstoreAddOutlined,
//   MenuOutlined,
//   StarOutlined,
//   CrownOutlined,
//   RocketOutlined,
//   LockOutlined,
//   VideoCameraOutlined
// } from "@ant-design/icons";

// import "./App.css";

// import Login from "./components/Login";
// import Register from "./components/Register";
// import Home from "./components/Home";
// import Profile from "./components/Profile";
// import BoardUser from "./components/BoardUser";
// import BoardModerator from "./components/BoardModerator";
// import BoardAdmin from "./components/admin/BoardAdmin";
// import Courses from "./components/cours/Courses";
// import CoursesByCategory from "./components/admin_and_user/CoursesByCategory";
// import About from "./components/about/About";
// import Contact from "./components/contact/Contact";
// import BecomeInstructor from "./components/becomeinstructor/BecomeInstructor";

// import { logout } from "./actions/auth";
// import CourseCreateForm from "./components/moderateur/CourseCreateForm";
// import LiveTrainingForm from "./components/moderateur/live-trainings/LiveTrainingForm";
// import LiveTrainingsList from "./components/moderateur/live-trainings/LiveTrainingsList";
// import LiveTrainingsPublic from "./components/user/live-trainings/LiveTrainingsPublic";
// import LiveTrainingDetails from "./components/user/live-trainings/LiveTrainingDetails";
// import MonerisLiveTrainingCheckoutPage from "./components/payment/MonerisLiveTrainingCheckoutPage";

// import ModeratorCourses from "./components/moderateur/ModeratorCourses";
// import AddSubjectForm from "./components/moderateur/AddSubjectForm";
// import MyPurchases from "./components/user/MyPurchases";
// import CourseDetails from "./components/user/CourseDetails";
// import PayPalSuccess from "./components/payment/PayPalSuccess";
// import PayPalCancel from "./components/payment/PayPalCancel";
// import MonerisCheckoutPage from "./components/payment/MonerisCheckoutPage";
// import TermsOfService from "./components/static_component/TermsOfService";

// import MissionValues from "./components/static_component/MissionValues";
// import Team from "./components/static_component/Team";
// import LegalNotices from "./components/static_component/LegalNotices";
// import PrivacyPolicy from "./components/static_component/PrivacyPolicy";
// import CookiePolicy from "./components/static_component/CookiePolicy";
// import FAQ from "./components/static_component/Faq";
// import { Footer } from "antd/es/layout/layout";
// import ChangePassword from "./components/user/ChangePassword";
// import ProfileManagement from "./components/ProfileManagement";
// import { GoogleOAuthProvider } from '@react-oauth/google';
// import NotificationDropdown from "./components/notification/NotificationDropdown";
// import CertificateVerify from "./components/moderateur/CertificateVerify";
// import SapLandingPage from "./components/admin/SapLandingPage";
// import CoursePreviewPage from "./components/cours/CoursePreviewPage";
// import CourseLandingPage from "./components/cours/CourseLandingPage";
// import ResetPassword from "./components/ResetPassword";
// import BadgeVerification from "./components/badge/BadgeVerification";
// import SplashScreen from "./components/splash/SplashScreen";

// const { Search } = Input;
// const { Text } = Typography;
// const GOOGLE_CLIENT_ID = "1000623363556-ik7v61ohar85d5h4b05s4jo86jqgpurt.apps.googleusercontent.com";

// /* ============ Couleurs Nomidya ============ */
// const C = {
//   blue: "#0054A6",
//   blueDark: "#003B75",
//   blueDeep: "#002147",
//   orange: "#E8860C",
//   orangeLight: "#FF8C00",
// };

// /* ================================================================
//    Layout principal avec Navbar + Footer
//    ================================================================ */
// const MainLayout = () => {
//   const [showModeratorBoard, setShowModeratorBoard] = useState(false);
//   const [showAdminBoard, setShowAdminBoard] = useState(false);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [isEditingSubject, setIsEditingSubject] = useState(false);
//   const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

//   const handleEditSubject = (subject) => {
//     setSelectedSubject(subject);
//     setIsEditingSubject(true);
//   };

//   const { user: currentUser } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const logOut = useCallback(() => {
//     dispatch(logout());
//     navigate("/login");
//   }, [dispatch, navigate]);

//   useEffect(() => {
//     if (currentUser) {
//       setShowModeratorBoard(currentUser.roles.includes("ROLE_MODERATOR"));
//       setShowAdminBoard(currentUser.roles.includes("ROLE_ADMIN"));
//     } else {
//       setShowModeratorBoard(false);
//       setShowAdminBoard(false);
//     }
//   }, [currentUser]);

//   /* ---- Nav link styles ---- */
//   const navLinkStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px',
//     padding: '7px 15px',
//     borderRadius: '20px',
//     transition: 'all 0.3s ease',
//     textDecoration: 'none',
//     color: '#fff',
//     fontWeight: '500',
//     fontSize: '13px',
//     background: 'rgba(255, 255, 255, 0.1)',
//     border: '1px solid rgba(255, 255, 255, 0.12)',
//     whiteSpace: 'nowrap',
//   };

//   const activeNavLinkStyle = {
//     ...navLinkStyle,
//     background: C.orange,
//     color: '#fff',
//     border: `1px solid ${C.orange}`,
//     boxShadow: `0 3px 12px ${C.orange}44`,
//   };

//   /* ---- Profile menu ---- */
//   const profileMenu = (
//     <Menu
//       style={{
//         borderRadius: '12px',
//         padding: '8px',
//         minWidth: '260px',
//         background: '#fff',
//         border: '1px solid #eaedf2',
//         boxShadow: '0 12px 32px rgba(0,0,0,0.1)',
//       }}
//     >
//       <Menu.Item key="user-info" disabled style={{ cursor: "default", background: 'transparent', padding: '16px 12px' }}>
//         <div style={{ textAlign: "center" }}>
//           <div style={{ position: 'relative', display: 'inline-block', marginBottom: '12px' }}>
//             <Avatar
//               size={56}
//               src={currentUser?.profileImage}
//               style={{
//                 background: !currentUser?.profileImage ? (
//                   showAdminBoard ? C.orange : showModeratorBoard ? "#00875A" : C.blue
//                 ) : undefined,
//                 border: `2px solid ${C.blue}22`,
//               }}
//               icon={!currentUser?.profileImage && <UserOutlined />}
//             />
//             {showAdminBoard && (
//               <CrownOutlined style={{
//                 position: 'absolute', top: -4, right: -4, color: C.orange,
//                 fontSize: 14, background: '#fff', borderRadius: '50%', padding: 2,
//               }} />
//             )}
//             {showModeratorBoard && !showAdminBoard && (
//               <StarOutlined style={{
//                 position: 'absolute', top: -4, right: -4, color: '#00875A',
//                 fontSize: 14, background: '#fff', borderRadius: '50%', padding: 2,
//               }} />
//             )}
//           </div>
//           <div>
//             <Text strong style={{ fontSize: 15, color: C.blueDark }}>{currentUser?.username}</Text>
//             <br />
//             <Text style={{ color: '#888', fontSize: 11 }}>{currentUser?.email}</Text>
//             <br />
//             <div style={{ marginTop: 6 }}>
//               {showAdminBoard && (
//                 <span style={{ background: C.orange, color: 'white', padding: '3px 10px', borderRadius: 12, fontSize: 9, fontWeight: 700 }}>
//                   ADMINISTRATEUR
//                 </span>
//               )}
//               {showModeratorBoard && !showAdminBoard && (
//                 <span style={{ background: '#00875A', color: 'white', padding: '3px 10px', borderRadius: 12, fontSize: 9, fontWeight: 700 }}>
//                   MODÉRATEUR
//                 </span>
//               )}
//               {!showAdminBoard && !showModeratorBoard && (
//                 <span style={{ background: C.blue, color: 'white', padding: '3px 10px', borderRadius: 12, fontSize: 9, fontWeight: 700 }}>
//                   UTILISATEUR
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>
//       </Menu.Item>
//       <Menu.Divider style={{ background: '#eaedf2' }} />

//       <Menu.Item key="profile" icon={<UserOutlined style={{ color: C.blue }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//         <Link to="/profile" style={{ color: '#333' }}>Mon Profil</Link>
//       </Menu.Item>

//       {showAdminBoard && (
//         <Menu.Item key="admin-dashboard" icon={<SettingOutlined style={{ color: C.orange }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//           <Link to="/admin" style={{ color: '#333' }}>Interface Admin</Link>
//         </Menu.Item>
//       )}

//       {showModeratorBoard && (
//         <>
//           <Menu.Item key="manage-courses" icon={<BookOutlined style={{ color: '#00875A' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//             <Link to="/mod/courses" style={{ color: '#333' }}>Mes Cours</Link>
//           </Menu.Item>
//           <Menu.Item key="create-course" icon={<AppstoreAddOutlined style={{ color: '#00875A' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//             <Link to="/mod/create-course" style={{ color: '#333' }}>Créer un Nouveau Cours</Link>
//           </Menu.Item>
//           {/* ✅ Formations Live */}
//           <Menu.Item key="my-live-trainings" icon={<VideoCameraOutlined style={{ color: '#ee5a6f' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//             <Link to="/mod/live-trainings" style={{ color: '#333' }}>🔴 Mes Formations Live</Link>
//           </Menu.Item>
//           <Menu.Item key="create-live-training" icon={<VideoCameraOutlined style={{ color: '#ee5a6f' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//             <Link to="/mod/create-live-training" style={{ color: '#333' }}>🔴 Créer Formation Live</Link>
//           </Menu.Item>
//         </>
//       )}

//       <Menu.Item key="purchases" icon={<ShoppingOutlined style={{ color: C.blue }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//         <Link to="/my-purchases" style={{ color: '#333' }}>Mes Achats</Link>
//       </Menu.Item>

//       <Menu.Item key="change-password" icon={<LockOutlined style={{ color: C.blue }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
//         <Link to="/change-password" style={{ color: '#333' }}>Changer le mot de passe</Link>
//       </Menu.Item>

//       <Menu.Divider style={{ background: '#eaedf2' }} />

//       <Menu.Item key="logout" icon={<LogoutOutlined style={{ color: '#DC2626' }} />} onClick={logOut}
//         style={{ borderRadius: 8, margin: '3px 0', background: '#fef2f2' }}>
//         <span style={{ color: '#DC2626' }}>Déconnexion</span>
//       </Menu.Item>
//     </Menu>
//   );

//   const loginMenu = (
//     <Menu style={{ borderRadius: 12, padding: 8, background: '#fff', border: '1px solid #eaedf2', boxShadow: '0 12px 32px rgba(0,0,0,0.1)' }}>
//       <Menu.Item key="login" style={{ borderRadius: 8, margin: '3px 0' }}>
//         <Link to="/login" style={{ color: '#333' }}>
//           <UserOutlined style={{ color: C.blue, marginRight: 8 }} /> Connexion
//         </Link>
//       </Menu.Item>
//       <Menu.Item key="register" style={{ borderRadius: 8, margin: '3px 0' }}>
//         <Link to="/register" style={{ color: '#333' }}>
//           <RocketOutlined style={{ color: C.orange, marginRight: 8 }} /> Créer un compte
//         </Link>
//       </Menu.Item>
//     </Menu>
//   );

//   /* ---- Mobile menu ---- */
//   const mobileMenu = (
//     <div style={{ padding: '20px' }}>
//       <div style={{ textAlign: 'center', marginBottom: 24 }}>
//         <img src="/img/nomidya.png" alt="Nomidya" style={{ height: 36 }} />
//       </div>

//       <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
//         {[
//           { to: "/home", icon: <HomeOutlined />, label: "Accueil" },
//           { to: "/courses", icon: <BookOutlined />, label: "Cours" },
//           { to: "/live-trainings", icon: <VideoCameraOutlined />, label: "Formations Live" },
//           { to: "/about", icon: <InfoCircleOutlined />, label: "À Propos" },
//           { to: "/contact", icon: <PhoneOutlined />, label: "Contact" },
//           { to: "/become-instructor", icon: <TeamOutlined />, label: "Formateur" },
//           { to: "/sap-access", icon: <RocketOutlined />, label: "Accès SAP" },
//         ].map(item => (
//           <Link key={item.to} to={item.to}
//             onClick={() => setMobileMenuVisible(false)}
//             style={{
//               display: 'flex', alignItems: 'center', gap: 8,
//               padding: '10px 16px', borderRadius: 10, color: 'white',
//               fontSize: 14, fontWeight: 500, textDecoration: 'none',
//               background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.1)',
//             }}>
//             {item.icon} {item.label}
//           </Link>
//         ))}
//       </div>

//       <Divider style={{ margin: '24px 0', borderColor: 'rgba(255,255,255,0.15)' }} />

//       <div style={{ textAlign: 'center' }}>
//         {currentUser ? (
//           <div>
//             <Avatar size={44} style={{ background: C.orange, marginBottom: 8 }} icon={<UserOutlined />} />
//             <div style={{ marginBottom: 12 }}>
//               <Text strong style={{ color: 'white' }}>{currentUser.username}</Text>
//             </div>
//             <Button danger icon={<LogoutOutlined />}
//               onClick={() => { logOut(); setMobileMenuVisible(false); }}
//               style={{ borderRadius: 20 }}>
//               Déconnexion
//             </Button>
//           </div>
//         ) : (
//           <Space direction="vertical" style={{ width: '100%' }}>
//             <Button type="primary" block
//               style={{ borderRadius: 20, height: 40, background: C.orange, borderColor: C.orange }}
//               onClick={() => { navigate('/login'); setMobileMenuVisible(false); }}>
//               Connexion
//             </Button>
//             <Button block style={{ borderRadius: 20, height: 40, color: 'white', borderColor: 'rgba(255,255,255,0.3)', background: 'transparent' }}
//               onClick={() => { navigate('/register'); setMobileMenuVisible(false); }}>
//               Créer un compte
//             </Button>
//           </Space>
//         )}
//       </div>
//     </div>
//   );

//   return (
//     <div className="app-container">
//       {/* ============ NAVBAR — Bleu Nomidya ============ */}
//       <nav style={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
//         background: `linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 50%, ${C.blueDark} 100%)`,
//         padding: '6px 0',
//         boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//       }}>
//         <div style={{ maxWidth: 1400, margin: '0 auto', padding: '0 20px' }}>
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 52 }}>

//             {/* Logo */}
//             <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
//               <div style={{
//                 background: 'rgba(255,255,255,0.88)',
//                 borderRadius: 10,
//                 padding: '3px 12px',
//                 display: 'flex',
//                 alignItems: 'center',
//               }}>
//                 <img src="/img/nomidya.png" alt="Nomidya"
//                   style={{ height: 48, transition: 'all 0.3s' }}
//                   onMouseEnter={e => e.target.style.transform = 'scale(1.03)'}
//                   onMouseLeave={e => e.target.style.transform = 'scale(1)'} />
//               </div>
//             </Link>

//             {/* Desktop menu */}
//             <div style={{ display: 'flex', alignItems: 'center', gap: 6 }} className="desktop-menu">
//               <NavLink to="/home" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
//                 <HomeOutlined /> <span className="nav-text">Accueil</span>
//               </NavLink>
//               <NavLink to="/courses" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
//                 <BookOutlined /> <span className="nav-text">Cours</span>
//               </NavLink>
//               <NavLink to="/live-trainings" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
//                 <VideoCameraOutlined /> <span className="nav-text">Live</span>
//               </NavLink>
//               <NavLink to="/about" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
//                 <InfoCircleOutlined /> <span className="nav-text">À Propos</span>
//               </NavLink>
//               <NavLink to="/contact" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
//                 <PhoneOutlined /> <span className="nav-text">Contact</span>
//               </NavLink>
//               <NavLink to="/become-instructor" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
//                 <TeamOutlined /> <span className="nav-text">Formateur</span>
//               </NavLink>
//               <NavLink to="/sap-access" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
//                 <RocketOutlined /> <span className="nav-text">Accès SAP</span>
//               </NavLink>
//             </div>

//             {/* Right actions */}
//             <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//               {/* Search */}
//               <div className="desktop-search" style={{ display: 'block' }}>
//                 <Search
//                   placeholder="Rechercher..."
//                   allowClear
//                   enterButton={<SearchOutlined />}
//                   size="middle"
//                   style={{ width: 200 }}
//                   styles={{
//                     input: {
//                       borderRadius: 20, border: 'none',
//                       background: 'rgba(255,255,255,0.95)',
//                     },
//                   }}
//                 />
//               </div>

//               {/* User / Login */}
//               {currentUser ? (
//                 <Dropdown overlay={profileMenu} placement="bottomRight">
//                   <Button type="text" style={{
//                     display: 'flex', alignItems: 'center', gap: 8,
//                     padding: '5px 12px', borderRadius: 20,
//                     background: 'rgba(255,255,255,0.12)',
//                     border: '1px solid rgba(255,255,255,0.15)',
//                     color: 'white', height: 38, maxWidth: 130,
//                   }}>
//                     <Avatar size={26} src={currentUser?.profileImage}
//                       style={{
//                         background: !currentUser?.profileImage ? (
//                           showAdminBoard ? C.orange : showModeratorBoard ? "#00875A" : "rgba(255,255,255,0.2)"
//                         ) : undefined,
//                       }}
//                       icon={!currentUser?.profileImage && <UserOutlined />} />
//                     <span className="desktop-username" style={{
//                       fontWeight: 500, fontSize: 12, overflow: 'hidden',
//                       textOverflow: 'ellipsis', whiteSpace: 'nowrap',
//                     }}>
//                       {currentUser.username}
//                     </span>
//                   </Button>
//                 </Dropdown>
//               ) : (
//                 <Dropdown overlay={loginMenu} placement="bottomRight">
//                   <Button type="primary" size="middle" style={{
//                     background: C.orange, border: 'none', borderRadius: 20,
//                     color: 'white', fontWeight: 700, height: 38,
//                     padding: '0 20px', boxShadow: `0 3px 12px ${C.orange}44`, fontSize: 13,
//                   }}>
//                     Connexion
//                   </Button>
//                 </Dropdown>
//               )}

//               {/* Mobile burger */}
//               <Button icon={<MenuOutlined />} type="text" size="middle"
//                 className="mobile-menu-btn"
//                 onClick={() => setMobileMenuVisible(true)}
//                 style={{
//                   color: 'white', background: 'rgba(255,255,255,0.1)',
//                   border: '1px solid rgba(255,255,255,0.15)',
//                   borderRadius: 8, display: 'none', width: 38, height: 38,
//                 }} />
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* CSS responsive */}
//       <style jsx>{`
//         @media (max-width: 1200px) {
//           .desktop-menu { display: none !important; }
//           .mobile-menu-btn { display: flex !important; }
//         }
//         @media (max-width: 1000px) {
//           .desktop-search { display: none !important; }
//         }
//         @media (max-width: 768px) {
//           .desktop-username { display: none !important; }
//         }
//         @media (max-width: 600px) {
//           .nav-text { display: none !important; }
//         }
//         .desktop-menu a:hover {
//           background: rgba(255, 255, 255, 0.18) !important;
//           transform: translateY(-1px);
//         }
//       `}</style>

//       {/* Drawer mobile — Bleu Nomidya */}
//       <Drawer
//         title={null} placement="right" width={280}
//         onClose={() => setMobileMenuVisible(false)}
//         open={mobileMenuVisible}
//         style={{ background: `linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%)` }}
//         bodyStyle={{ background: `linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%)`, padding: 0 }}
//       >
//         {mobileMenu}
//       </Drawer>

//       {/* Content */}
//       <div style={{ marginTop: 68, minHeight: '100vh' }}>
//         <div className="custom-container">
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/home" element={<Home />} />
//             <Route path="/login" element={<Login />} />
//             <Route path="/register" element={<Register />} />
//             <Route path="/admin" element={<BoardAdmin />} />
//             <Route path="/courses" element={<CoursesByCategory />} />
//             <Route path="/about" element={<About />} />            <Route path="/contact" element={<Contact />} />
//             <Route path="/become-instructor" element={<BecomeInstructor />} />
//             <Route path="/mod" element={<BoardModerator />} />
//             <Route path="/mod/create-course" element={<CourseCreateForm />} />
//             <Route path="/mod/courses" element={<ModeratorCourses />} />
//             <Route path="/user" element={<BoardUser />} />
//             <Route path="/mod/courses/edit/:courseId" element={<CourseCreateForm btnText="Modifier le cours" />} />

//             {/* ✅ Routes Formation Live */}
//             <Route path="/live-trainings" element={<LiveTrainingsPublic />} />
//             <Route path="/live-training/:id" element={<LiveTrainingDetails />} />
//             <Route path="/pay/live-training/:id" element={<MonerisLiveTrainingCheckoutPage />} />


//             <Route path="/mod/live-trainings" element={<LiveTrainingsList />} />
//             <Route path="/mod/create-live-training" element={<LiveTrainingForm />} />
//             <Route path="/mod/live-trainings/edit/:id" element={<LiveTrainingForm btnText="Modifier la formation live" />} />

//             <Route path="/mod/courses/:courseId/add-subject" element={<AddSubjectForm />} />
//             <Route path="/my-purchases" element={<MyPurchases />} />
//             <Route path="/learning/course/:id" element={<CourseDetails />} />
//             <Route path="/payment/success" element={<PayPalSuccess />} />
//             <Route path="/payment/cancel" element={<PayPalCancel />} />
//             <Route path="/pay/moneris" element={<MonerisCheckoutPage />} />
//             <Route path="/mission-values" element={<MissionValues />} />
//             <Route path="/team" element={<Team />} />
//             <Route path="/legal-notices" element={<LegalNotices />} />
//             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//             <Route path="/cookie-policy" element={<CookiePolicy />} />
//             <Route path="/faq" element={<FAQ />} />
//             <Route path="/change-password" element={<ChangePassword />} />
//             <Route path="/terms-of-service" element={<TermsOfService />} />
//             <Route path="/profile" element={<Profile />} />
//             <Route path="/profile-management" element={<ProfileManagement />} />
//             <Route path="/course-preview/:id" element={<CoursePreviewPage />} />
//             <Route path="/course/:id" element={<CourseLandingPage />} />
//             <Route path="/reset-password" element={<ResetPassword />} />
//             <Route path="/certificate/verify/:code" element={<CertificateVerify />} />
//             <Route path="/badge/verify/:code" element={<BadgeVerification />} />
//           </Routes>
//         </div>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// /* ================================================================
//    App principal
//    ================================================================ */
// const App = () => {
//   return (
//     <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
//       <Routes>
//         <Route path="/sap-access" element={<SapLandingPage />} />
//         <Route path="/certificate/verify/:code" element={<CertificateVerify />} />
//         <Route path="/badge/verify/:code" element={<BadgeVerification />} />
//         <Route path="/reset-password" element={<ResetPassword />} />
//         <Route path="/*" element={<MainLayout />} />
//       </Routes>
//     </GoogleOAuthProvider>
//   );
// };

// export default App;

import React, { useState, useEffect, useCallback } from "react";
import { Routes, Route, NavLink, Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Menu,
  Dropdown,
  Avatar,
  Button,
  Badge,
  Input,
  Drawer,
  Space,
  Divider,
  Typography
} from "antd";
import {
  HomeOutlined,
  BookOutlined,
  InfoCircleOutlined,
  PhoneOutlined,
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  ShoppingOutlined,
  SearchOutlined,
  AppstoreAddOutlined,
  MenuOutlined,
  StarOutlined,
  CrownOutlined,
  RocketOutlined,
  LockOutlined,
  VideoCameraOutlined
} from "@ant-design/icons";

import "./App.css";

import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/Home";
import Profile from "./components/Profile";
import BoardUser from "./components/BoardUser";
import BoardModerator from "./components/BoardModerator";
import BoardAdmin from "./components/admin/BoardAdmin";
import Courses from "./components/cours/Courses";
import CoursesByCategory from "./components/admin_and_user/CoursesByCategory";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import BecomeInstructor from "./components/becomeinstructor/BecomeInstructor";

import { logout } from "./actions/auth";
import CourseCreateForm from "./components/moderateur/CourseCreateForm";
import LiveTrainingForm from "./components/moderateur/live-trainings/LiveTrainingForm";
import LiveTrainingsList from "./components/moderateur/live-trainings/LiveTrainingsList";
import LiveTrainingsPublic from "./components/user/live-trainings/LiveTrainingsPublic";
import LiveTrainingDetails from "./components/user/live-trainings/LiveTrainingDetails";
import MonerisLiveTrainingCheckoutPage from "./components/payment/MonerisLiveTrainingCheckoutPage";

import ModeratorCourses from "./components/moderateur/ModeratorCourses";
import AddSubjectForm from "./components/moderateur/AddSubjectForm";
import MyPurchases from "./components/user/MyPurchases";
import CourseDetails from "./components/user/CourseDetails";
import PayPalSuccess from "./components/payment/PayPalSuccess";
import PayPalCancel from "./components/payment/PayPalCancel";
import MonerisCheckoutPage from "./components/payment/MonerisCheckoutPage";
import TermsOfService from "./components/static_component/TermsOfService";

import MissionValues from "./components/static_component/MissionValues";
import Team from "./components/static_component/Team";
import LegalNotices from "./components/static_component/LegalNotices";
import PrivacyPolicy from "./components/static_component/PrivacyPolicy";
import CookiePolicy from "./components/static_component/CookiePolicy";
import FAQ from "./components/static_component/Faq";
import { Footer } from "antd/es/layout/layout";
import ChangePassword from "./components/user/ChangePassword";
import ProfileManagement from "./components/ProfileManagement";
import { GoogleOAuthProvider } from '@react-oauth/google';
import NotificationDropdown from "./components/notification/NotificationDropdown";
import CertificateVerify from "./components/moderateur/CertificateVerify";
import SapLandingPage from "./components/admin/SapLandingPage";
import CoursePreviewPage from "./components/cours/CoursePreviewPage";
import CourseLandingPage from "./components/cours/CourseLandingPage";
import ResetPassword from "./components/ResetPassword";
import BadgeVerification from "./components/badge/BadgeVerification";
import SplashScreen from "./components/splash/SplashScreen";

// ✅ NOUVEAU : Hook d'inactivité (auto-logout après 30 min)
import useIdleTimer from "./hooks/useIdleTimer";

const { Search } = Input;
const { Text } = Typography;
const GOOGLE_CLIENT_ID = "1000623363556-ik7v61ohar85d5h4b05s4jo86jqgpurt.apps.googleusercontent.com";

/* ============ Couleurs Nomidya ============ */
const C = {
  blue: "#0054A6",
  blueDark: "#003B75",
  blueDeep: "#002147",
  orange: "#E8860C",
  orangeLight: "#FF8C00",
};

/* ================================================================
   Layout principal avec Navbar + Footer
   ================================================================ */
const MainLayout = () => {
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  // ✅ NOUVEAU : Active la détection d'inactivité (30 min)
  //    Toast d'avertissement à 28 min, déconnexion auto à 30 min
  useIdleTimer();

  const handleEditSubject = (subject) => {
    setSelectedSubject(subject);
    setIsEditingSubject(true);
  };

  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOut = useCallback(() => {
    dispatch(logout());
    navigate("/login");
  }, [dispatch, navigate]);

  useEffect(() => {
    if (currentUser) {
      setShowModeratorBoard(currentUser.roles.includes("ROLE_MODERATOR"));
      setShowAdminBoard(currentUser.roles.includes("ROLE_ADMIN"));
    } else {
      setShowModeratorBoard(false);
      setShowAdminBoard(false);
    }
  }, [currentUser]);

  /* ---- Nav link styles ---- */
  const navLinkStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '7px 15px',
    borderRadius: '20px',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    color: '#fff',
    fontWeight: '500',
    fontSize: '13px',
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    whiteSpace: 'nowrap',
  };

  const activeNavLinkStyle = {
    ...navLinkStyle,
    background: C.orange,
    color: '#fff',
    border: `1px solid ${C.orange}`,
    boxShadow: `0 3px 12px ${C.orange}44`,
  };

  /* ---- Profile menu ---- */
  const profileMenu = (
    <Menu
      style={{
        borderRadius: '12px',
        padding: '8px',
        minWidth: '260px',
        background: '#fff',
        border: '1px solid #eaedf2',
        boxShadow: '0 12px 32px rgba(0,0,0,0.1)',
      }}
    >
      <Menu.Item key="user-info" disabled style={{ cursor: "default", background: 'transparent', padding: '16px 12px' }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ position: 'relative', display: 'inline-block', marginBottom: '12px' }}>
            <Avatar
              size={56}
              src={currentUser?.profileImage}
              style={{
                background: !currentUser?.profileImage ? (
                  showAdminBoard ? C.orange : showModeratorBoard ? "#00875A" : C.blue
                ) : undefined,
                border: `2px solid ${C.blue}22`,
              }}
              icon={!currentUser?.profileImage && <UserOutlined />}
            />
            {showAdminBoard && (
              <CrownOutlined style={{
                position: 'absolute', top: -4, right: -4, color: C.orange,
                fontSize: 14, background: '#fff', borderRadius: '50%', padding: 2,
              }} />
            )}
            {showModeratorBoard && !showAdminBoard && (
              <StarOutlined style={{
                position: 'absolute', top: -4, right: -4, color: '#00875A',
                fontSize: 14, background: '#fff', borderRadius: '50%', padding: 2,
              }} />
            )}
          </div>
          <div>
            <Text strong style={{ fontSize: 15, color: C.blueDark }}>{currentUser?.username}</Text>
            <br />
            <Text style={{ color: '#888', fontSize: 11 }}>{currentUser?.email}</Text>
            <br />
            <div style={{ marginTop: 6 }}>
              {showAdminBoard && (
                <span style={{ background: C.orange, color: 'white', padding: '3px 10px', borderRadius: 12, fontSize: 9, fontWeight: 700 }}>
                  ADMINISTRATEUR
                </span>
              )}
              {showModeratorBoard && !showAdminBoard && (
                <span style={{ background: '#00875A', color: 'white', padding: '3px 10px', borderRadius: 12, fontSize: 9, fontWeight: 700 }}>
                  MODÉRATEUR
                </span>
              )}
              {!showAdminBoard && !showModeratorBoard && (
                <span style={{ background: C.blue, color: 'white', padding: '3px 10px', borderRadius: 12, fontSize: 9, fontWeight: 700 }}>
                  UTILISATEUR
                </span>
              )}
            </div>
          </div>
        </div>
      </Menu.Item>
      <Menu.Divider style={{ background: '#eaedf2' }} />

      <Menu.Item key="profile" icon={<UserOutlined style={{ color: C.blue }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
        <Link to="/profile" style={{ color: '#333' }}>Mon Profil</Link>
      </Menu.Item>

      {showAdminBoard && (
        <Menu.Item key="admin-dashboard" icon={<SettingOutlined style={{ color: C.orange }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
          <Link to="/admin" style={{ color: '#333' }}>Interface Admin</Link>
        </Menu.Item>
      )}

      {showModeratorBoard && (
        <>
          <Menu.Item key="manage-courses" icon={<BookOutlined style={{ color: '#00875A' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
            <Link to="/mod/courses" style={{ color: '#333' }}>Mes Cours</Link>
          </Menu.Item>
          <Menu.Item key="create-course" icon={<AppstoreAddOutlined style={{ color: '#00875A' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
            <Link to="/mod/create-course" style={{ color: '#333' }}>Créer un Nouveau Cours</Link>
          </Menu.Item>
          {/* ✅ Formations Live */}
          <Menu.Item key="my-live-trainings" icon={<VideoCameraOutlined style={{ color: '#ee5a6f' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
            <Link to="/mod/live-trainings" style={{ color: '#333' }}>🔴 Mes Formations Live</Link>
          </Menu.Item>
          <Menu.Item key="create-live-training" icon={<VideoCameraOutlined style={{ color: '#ee5a6f' }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
            <Link to="/mod/create-live-training" style={{ color: '#333' }}>🔴 Créer Formation Live</Link>
          </Menu.Item>
        </>
      )}

      <Menu.Item key="purchases" icon={<ShoppingOutlined style={{ color: C.blue }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
        <Link to="/my-purchases" style={{ color: '#333' }}>Mes Achats</Link>
      </Menu.Item>

      <Menu.Item key="change-password" icon={<LockOutlined style={{ color: C.blue }} />} style={{ borderRadius: 8, margin: '3px 0' }}>
        <Link to="/change-password" style={{ color: '#333' }}>Changer le mot de passe</Link>
      </Menu.Item>

      <Menu.Divider style={{ background: '#eaedf2' }} />

      <Menu.Item key="logout" icon={<LogoutOutlined style={{ color: '#DC2626' }} />} onClick={logOut}
        style={{ borderRadius: 8, margin: '3px 0', background: '#fef2f2' }}>
        <span style={{ color: '#DC2626' }}>Déconnexion</span>
      </Menu.Item>
    </Menu>
  );

  const loginMenu = (
    <Menu style={{ borderRadius: 12, padding: 8, background: '#fff', border: '1px solid #eaedf2', boxShadow: '0 12px 32px rgba(0,0,0,0.1)' }}>
      <Menu.Item key="login" style={{ borderRadius: 8, margin: '3px 0' }}>
        <Link to="/login" style={{ color: '#333' }}>
          <UserOutlined style={{ color: C.blue, marginRight: 8 }} /> Connexion
        </Link>
      </Menu.Item>
      <Menu.Item key="register" style={{ borderRadius: 8, margin: '3px 0' }}>
        <Link to="/register" style={{ color: '#333' }}>
          <RocketOutlined style={{ color: C.orange, marginRight: 8 }} /> Créer un compte
        </Link>
      </Menu.Item>
    </Menu>
  );

  /* ---- Mobile menu ---- */
  const mobileMenu = (
    <div style={{ padding: '20px' }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img src="/img/nomidya.png" alt="Nomidya" style={{ height: 36 }} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {[
          { to: "/home", icon: <HomeOutlined />, label: "Accueil" },
          { to: "/courses", icon: <BookOutlined />, label: "Cours" },
          { to: "/live-trainings", icon: <VideoCameraOutlined />, label: "Formations Live" },
          { to: "/about", icon: <InfoCircleOutlined />, label: "À Propos" },
          { to: "/contact", icon: <PhoneOutlined />, label: "Contact" },
          { to: "/become-instructor", icon: <TeamOutlined />, label: "Formateur" },
          { to: "/sap-access", icon: <RocketOutlined />, label: "Accès SAP" },
        ].map(item => (
          <Link key={item.to} to={item.to}
            onClick={() => setMobileMenuVisible(false)}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '10px 16px', borderRadius: 10, color: 'white',
              fontSize: 14, fontWeight: 500, textDecoration: 'none',
              background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.1)',
            }}>
            {item.icon} {item.label}
          </Link>
        ))}
      </div>

      <Divider style={{ margin: '24px 0', borderColor: 'rgba(255,255,255,0.15)' }} />

      <div style={{ textAlign: 'center' }}>
        {currentUser ? (
          <div>
            <Avatar size={44} style={{ background: C.orange, marginBottom: 8 }} icon={<UserOutlined />} />
            <div style={{ marginBottom: 12 }}>
              <Text strong style={{ color: 'white' }}>{currentUser.username}</Text>
            </div>
            <Button danger icon={<LogoutOutlined />}
              onClick={() => { logOut(); setMobileMenuVisible(false); }}
              style={{ borderRadius: 20 }}>
              Déconnexion
            </Button>
          </div>
        ) : (
          <Space direction="vertical" style={{ width: '100%' }}>
            <Button type="primary" block
              style={{ borderRadius: 20, height: 40, background: C.orange, borderColor: C.orange }}
              onClick={() => { navigate('/login'); setMobileMenuVisible(false); }}>
              Connexion
            </Button>
            <Button block style={{ borderRadius: 20, height: 40, color: 'white', borderColor: 'rgba(255,255,255,0.3)', background: 'transparent' }}
              onClick={() => { navigate('/register'); setMobileMenuVisible(false); }}>
              Créer un compte
            </Button>
          </Space>
        )}
      </div>
    </div>
  );

  return (
    <div className="app-container">
      {/* ============ NAVBAR — Bleu Nomidya ============ */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        background: `linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 50%, ${C.blueDark} 100%)`,
        padding: '6px 0',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      }}>
        <div style={{ maxWidth: 1400, margin: '0 auto', padding: '0 20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 52 }}>

            {/* Logo */}
            <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{
                background: 'rgba(255,255,255,0.88)',
                borderRadius: 10,
                padding: '3px 12px',
                display: 'flex',
                alignItems: 'center',
              }}>
                <img src="/img/nomidya.png" alt="Nomidya"
                  style={{ height: 48, transition: 'all 0.3s' }}
                  onMouseEnter={e => e.target.style.transform = 'scale(1.03)'}
                  onMouseLeave={e => e.target.style.transform = 'scale(1)'} />
              </div>
            </Link>

            {/* Desktop menu */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }} className="desktop-menu">
              <NavLink to="/home" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
                <HomeOutlined /> <span className="nav-text">Accueil</span>
              </NavLink>
              <NavLink to="/courses" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
                <BookOutlined /> <span className="nav-text">Cours</span>
              </NavLink>
              <NavLink to="/live-trainings" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
                <VideoCameraOutlined /> <span className="nav-text">Live</span>
              </NavLink>
              <NavLink to="/about" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
                <InfoCircleOutlined /> <span className="nav-text">À Propos</span>
              </NavLink>
              <NavLink to="/contact" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
                <PhoneOutlined /> <span className="nav-text">Contact</span>
              </NavLink>
              <NavLink to="/become-instructor" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
                <TeamOutlined /> <span className="nav-text">Formateur</span>
              </NavLink>
              <NavLink to="/sap-access" style={({ isActive }) => isActive ? activeNavLinkStyle : navLinkStyle}>
                <RocketOutlined /> <span className="nav-text">Accès SAP</span>
              </NavLink>
            </div>

            {/* Right actions */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              {/* Search */}
              <div className="desktop-search" style={{ display: 'block' }}>
                <Search
                  placeholder="Rechercher..."
                  allowClear
                  enterButton={<SearchOutlined />}
                  size="middle"
                  style={{ width: 200 }}
                  styles={{
                    input: {
                      borderRadius: 20, border: 'none',
                      background: 'rgba(255,255,255,0.95)',
                    },
                  }}
                />
              </div>

              {/* User / Login */}
              {currentUser ? (
                <Dropdown overlay={profileMenu} placement="bottomRight">
                  <Button type="text" style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '5px 12px', borderRadius: 20,
                    background: 'rgba(255,255,255,0.12)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    color: 'white', height: 38, maxWidth: 130,
                  }}>
                    <Avatar size={26} src={currentUser?.profileImage}
                      style={{
                        background: !currentUser?.profileImage ? (
                          showAdminBoard ? C.orange : showModeratorBoard ? "#00875A" : "rgba(255,255,255,0.2)"
                        ) : undefined,
                      }}
                      icon={!currentUser?.profileImage && <UserOutlined />} />
                    <span className="desktop-username" style={{
                      fontWeight: 500, fontSize: 12, overflow: 'hidden',
                      textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}>
                      {currentUser.username}
                    </span>
                  </Button>
                </Dropdown>
              ) : (
                <Dropdown overlay={loginMenu} placement="bottomRight">
                  <Button type="primary" size="middle" style={{
                    background: C.orange, border: 'none', borderRadius: 20,
                    color: 'white', fontWeight: 700, height: 38,
                    padding: '0 20px', boxShadow: `0 3px 12px ${C.orange}44`, fontSize: 13,
                  }}>
                    Connexion
                  </Button>
                </Dropdown>
              )}

              {/* Mobile burger */}
              <Button icon={<MenuOutlined />} type="text" size="middle"
                className="mobile-menu-btn"
                onClick={() => setMobileMenuVisible(true)}
                style={{
                  color: 'white', background: 'rgba(255,255,255,0.1)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  borderRadius: 8, display: 'none', width: 38, height: 38,
                }} />
            </div>
          </div>
        </div>
      </nav>

      {/* CSS responsive */}
      <style jsx>{`
        @media (max-width: 1200px) {
          .desktop-menu { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
        }
        @media (max-width: 1000px) {
          .desktop-search { display: none !important; }
        }
        @media (max-width: 768px) {
          .desktop-username { display: none !important; }
        }
        @media (max-width: 600px) {
          .nav-text { display: none !important; }
        }
        .desktop-menu a:hover {
          background: rgba(255, 255, 255, 0.18) !important;
          transform: translateY(-1px);
        }
      `}</style>

      {/* Drawer mobile — Bleu Nomidya */}
      <Drawer
        title={null} placement="right" width={280}
        onClose={() => setMobileMenuVisible(false)}
        open={mobileMenuVisible}
        style={{ background: `linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%)` }}
        bodyStyle={{ background: `linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%)`, padding: 0 }}
      >
        {mobileMenu}
      </Drawer>

      {/* Content */}
      <div style={{ marginTop: 68, minHeight: '100vh' }}>
        <div className="custom-container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<BoardAdmin />} />
            <Route path="/courses" element={<CoursesByCategory />} />
            <Route path="/about" element={<About />} />            <Route path="/contact" element={<Contact />} />
            <Route path="/become-instructor" element={<BecomeInstructor />} />
            <Route path="/mod" element={<BoardModerator />} />
            <Route path="/mod/create-course" element={<CourseCreateForm />} />
            <Route path="/mod/courses" element={<ModeratorCourses />} />
            <Route path="/user" element={<BoardUser />} />
            <Route path="/mod/courses/edit/:courseId" element={<CourseCreateForm btnText="Modifier le cours" />} />

            {/* ✅ Routes Formation Live */}
            <Route path="/live-trainings" element={<LiveTrainingsPublic />} />
            <Route path="/live-training/:id" element={<LiveTrainingDetails />} />
            <Route path="/pay/live-training/:id" element={<MonerisLiveTrainingCheckoutPage />} />


            <Route path="/mod/live-trainings" element={<LiveTrainingsList />} />
            <Route path="/mod/create-live-training" element={<LiveTrainingForm />} />
            <Route path="/mod/live-trainings/edit/:id" element={<LiveTrainingForm btnText="Modifier la formation live" />} />

            <Route path="/mod/courses/:courseId/add-subject" element={<AddSubjectForm />} />
            <Route path="/my-purchases" element={<MyPurchases />} />
            <Route path="/learning/course/:id" element={<CourseDetails />} />
            <Route path="/payment/success" element={<PayPalSuccess />} />
            <Route path="/payment/cancel" element={<PayPalCancel />} />
            <Route path="/pay/moneris" element={<MonerisCheckoutPage />} />
            <Route path="/mission-values" element={<MissionValues />} />
            <Route path="/team" element={<Team />} />
            <Route path="/legal-notices" element={<LegalNotices />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile-management" element={<ProfileManagement />} />
            <Route path="/course-preview/:id" element={<CoursePreviewPage />} />
            <Route path="/course/:id" element={<CourseLandingPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/certificate/verify/:code" element={<CertificateVerify />} />
            <Route path="/badge/verify/:code" element={<BadgeVerification />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  );
};

/* ================================================================
   App principal
   ================================================================ */
const App = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Routes>
        <Route path="/sap-access" element={<SapLandingPage />} />
        <Route path="/certificate/verify/:code" element={<CertificateVerify />} />
        <Route path="/badge/verify/:code" element={<BadgeVerification />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/*" element={<MainLayout />} />
      </Routes>
    </GoogleOAuthProvider>
  );
};

export default App;